import { Component } from '@angular/core';
import { FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { Adresse } from '../../../core/models/adresse.model';
import { BienImmobilier } from '../../../core/models/bien-immobilier.model';
import { BienService } from '../../../core/services/bien.service';
import { APP_ROUTES } from '../../../core/constants/app-routes';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-ajout-bien',
    templateUrl: './ajout-bien.component.html',
    styleUrls: ['./ajout-bien.component.css'],
    imports: [FormsModule, ReactiveFormsModule, RouterLink, TranslateModule]
})
export class AjoutBienComponent {
  saving = false;
  error = false;
  readonly routes = APP_ROUTES;

  readonly form = this.fb.nonNullable.group({
    titre: ['', Validators.required],
    rue: ['', Validators.required],
    codePostal: ['', Validators.required],
    ville: ['', Validators.required],
    complement: [''],
    anneeConstruction: [''],
  });

  constructor(
    private readonly fb: FormBuilder,
    private readonly bienService: BienService,
    private readonly router: Router
  ) {}

  submit(): void {
    if (this.form.invalid || this.saving) {
      this.form.markAllAsTouched();
      return;
    }

    const value = this.form.getRawValue();
    const adresse = new Adresse();
    adresse.rueDto = value.rue.trim();
    adresse.codePostalDto = value.codePostal.trim();
    adresse.villeDto = value.ville.trim();
    if (value.complement.trim()) {
      adresse.complementDto = value.complement.trim();
    }

    const bien = new BienImmobilier();
    bien.titreDto = value.titre.trim();
    bien.adresseDto = adresse;
    const annee = value.anneeConstruction.trim();
    if (annee) {
      const parsed = Number(annee);
      if (Number.isFinite(parsed)) {
        bien.anneeConstructionDto = Math.trunc(parsed);
      }
    }

    this.saving = true;
    this.error = false;

    this.bienService.create(bien).subscribe({
      next: (created) => {
        const id = created?.idBienDto;
        if (id) {
          this.router.navigate([APP_ROUTES.logements, id]);
          return;
        }
        this.router.navigate([APP_ROUTES.logements]);
      },
      error: () => {
        this.saving = false;
        this.error = true;
      },
    });
  }
}
